import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=c0558e98&scoped=true&"
var script = {}
import style0 from "./Check.vue?vue&type=style&index=0&id=c0558e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0558e98",
  null
  
)

export default component.exports